import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ChangeDetectorRef,
    SimpleChanges,
    OnChanges, ChangeDetectionStrategy} from "@angular/core";

@Component({ standalone: false,
    selector: "irb-com-inlineedit",
    templateUrl: "./inlineedit.component.html",
    styleUrls: ["./inlineedit.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComInlineEditComponent implements OnInit, OnChanges {
    private originalData: string;
    _data: any;
    _toolTipMessage: any;
    _toolTipShow: boolean = false;
    @Input()
    regExp = /[~`!#$%\^&*+=\-\[\]\\';/{}|\\":<>\?]/g;
    @Output() save = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();
    @Output() change = new EventEmitter<boolean>();
    @Input() customValidationFunction: (args: any) => boolean;
    @Input() customValidationOverride: boolean = false;

    @Input()
    maxlength: string | number = '';

    @Input()
    defaultTooltip: string;

    @Input()
    allowSpecialCharacters: boolean = false;
    isValid:boolean=false;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.toolTipShow = false;
        this.originalData = this.data;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.tooltipMessage && changes.tooltipMessage.currentValue !== "") {
            this.toolTipShow = true;
        } else {
            this.toolTipShow = false;
        }
    }

    cancel() {
        this.toolTipShow = false;
        this.close.emit(true);
    }

    tooltipHide() {
        this.toolTipShow = false;
        this.change.emit(true);
        if (this.maxlength && this.data && this.data.length === Number(this.maxlength)) {
            this.tooltipMessage = this.maxlength + ' characters max';
            this.toolTipShow = true;
        } else {
            this.tooltipMessage = '';
            this.isValid=true;
        }
    }

    proceed() {
        let re: RegExp =  new RegExp(this.regExp); //  /[~`!#$%\^&*+=\-\[\]\\';/{}|\\":<>\?]/g;
        let isValid = false;
        
        if (this.allowSpecialCharacters) {
            isValid = ['@','+','-','='].indexOf(this.data.charAt(0)) === -1;
        } else {
            isValid = !re.test(this.data) && ['@','+','-','='].indexOf(this.data.charAt(0)) === -1;
        }

        if(this.customValidationFunction) {
            let isValidCustom = this.customValidationFunction(this.data);

            if(this.customValidationOverride) {
                isValid = isValidCustom;
            } else {
                isValid = isValid && isValidCustom;
            }            
        }

        if (isValid) {
            if (this.originalData !== this.data) {
                this.save.emit(this.data);
            } else {
                this.cancel();
            }
        } else {
            this.tooltipMessage = this.tooltipMessage || this.defaultTooltip;
            this.toolTipShow = true;
        }
    }

    @Input()
    get data(): any {
        return this._data;
    }

    set data(d: any) {
        this._data = d;
    }

    @Input()
    get tooltipMessage(): any {
        return this._toolTipMessage;

    }

    set tooltipMessage(d: any) {
        this._toolTipMessage = d;
        this.cdr.detectChanges();
    }

    get toolTipShow(): any {
        return this._toolTipShow;
    }

    set toolTipShow(d: any) {
        this._toolTipShow = d;
    }
}
